var React = require('react');
import { Load } from '../common/basic';
import enums from '../../config/enums';
import axios from 'axios';
import { PersonalDetailsCol } from '../common/userData';

module.exports = class PatientDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: '',
            SkinType: '',
            Subscription: '',
            Phone: '',
            Email: '',
            Address: '',
            Country: '',
            Doctor: 'Not assigned'
        }
    }

    componentDidMount() {
        this
            ._loading
            .Show();

        // Chart.defaults.global.legend.display = true;

        axios
            .get("/data/getPatientDetails/" + this.props.patientID)
            .then(function (data) {
                var userData = data.data[0];
                this.props.updateDoctor(userData.DoctorID);
                this
                    ._loading
                    .Hide();

                var initial;
                if (userData.Gender == "Male") {
                    initial = "Mr. ";
                } else {
                    initial = "Mrs. ";
                }
                this.setState({
                    DoctorID: userData.DoctorID,
                    connectedUserID: this.props.connectedUserID,
                    Name: initial + userData.FirstName + ' ' + userData.LastName,
                    SkinType: userData.SkinTypeDesc,
                    SkinTypeColor: userData.SkinTypeColor,
                    Subscription: userData.Subscription,
                    Phone: userData.CellPhoneNumber,
                    Email: userData.Email,
                    Address: userData.Address,
                    Country: userData.Country,
                    Doctor: userData.DoctorFirstName + ' ' + userData.DoctorLastName
                });

            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }

    render() {
        var glyphiconPadding = {
            "paddingRight": "7px"
        };
        var chatUrl = "/chat/" + this.props.patientID;
        var chatClass = 'profileEdit';
        if (this.state.connectedUserID != this.state.DoctorID) {
            chatClass = "hidden";
        }

        return (
            <div className='PatientDetails UserDetails'>

                <div className='container'>
                    <Load
                        ref={(loading) => {
                            this._loading = loading;
                        }} />

                    <div className='Name'>
                        {this.state.Name}
                        <div className={chatClass}>
                            <a href={chatUrl}>Start chat</a>
                        </div>
                    </div>

                    <div className='float-left'>
                        <PersonalDetailsCol FieldName="Skin Type:" FieldValue={this.state.SkinType} />
                        <PersonalDetailsCol
                            FieldName="Subscription:"
                            FieldValue={this.state.Subscription} />
                        <PersonalDetailsCol FieldName="Phone:" FieldValue={this.state.Phone} />
                        <PersonalDetailsCol FieldName="Email:" FieldValue={this.state.Email} />
                    </div>
                    <div className='float-left'>
                        <PersonalDetailsCol FieldName="Address:" FieldValue={this.state.Address} />
                        <PersonalDetailsCol FieldName="Country:" FieldValue={this.state.Country} />
                        <PersonalDetailsCol FieldName="Doctor:" FieldValue={this.state.Doctor} />
                    </div>

                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./modules/patientSummary/PatientDetails.jsx